export default __webpack_public_path__ + "static/media/mountain4.b2d8aefa.png";